/**
 * Homepage ATF regions A/B variant helpers.
 * Production: Intelligems adds body class `ab-home-atf-regions` to the variant group.
 * Dev/manual preview: append ?ab_home_atf_regions=1 to the homepage URL.
 * Active state: adds `.is-active` on press so the brown chip shows before navigation.
 */
(function () {
  var params = new URLSearchParams(window.location.search);
  var preview = params.get('ab_home_atf_regions') === '1';

  function activatePreview() {
    document.body.classList.add('ab-home-atf-regions');
  }

  function bindActiveState() {
    var root = document.querySelector('[id$="__collection_image_nav_JhfN4z"]');
    if (!root) return;
    var items = root.querySelectorAll('.collection-image-nav__item');
    items.forEach(function (item) {
      item.addEventListener(
        'pointerdown',
        function () {
          items.forEach(function (el) {
            el.classList.remove('is-active');
          });
          item.classList.add('is-active');
        },
        { passive: true }
      );
    });
  }

  function init() {
    if (preview) activatePreview();
    if (document.body.classList.contains('ab-home-atf-regions') || preview) {
      bindActiveState();
    }
  }

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Intelligems may add the body class slightly after this script runs
  if (!preview) {
    var observer = new MutationObserver(function () {
      if (document.body.classList.contains('ab-home-atf-regions')) {
        bindActiveState();
        observer.disconnect();
      }
    });
    if (document.body) {
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }
})();
